import { BaseMapper } from '@shared/data';
import { MedicalDocumentationResponseDto } from '../../../app-layers/infrastructure/interface/dto/documentation/medical-documentation-response-dto';
import { MedicalDocumentationModel } from '../../interface/documentation/medical-documentation.model';

export class MedicalDocumentationResponseMapper extends BaseMapper<MedicalDocumentationModel, MedicalDocumentationResponseDto> {
    public mapDtoToModel(dto: MedicalDocumentationResponseDto): MedicalDocumentationModel {
        return {
            id: dto.id,
            maskedCustomerId: dto.maskedCustomerId,
            maskedInsuranceId: dto.maskedInsuranceId,
            maskedDocumentIds: dto.maskedDocumentIds,
            medicalCareType: dto.medicalCareType,
            accidentDate: this.stringDateToDayjs(dto.accidentDate),
            pastMedicalConditions: dto.pastMedicalConditions,
            pastMedicalConditionsDescription: dto.pastMedicalConditionsDescription,
            customerComment: dto.customerComment,
            canSubmitClaim: dto.canSubmitClaim,
            claimSubmitted: dto.claimSubmitted,
            claimStatus: dto.claimStatus,
            claimNumber: dto.claimNumber,
            claimSubmittedDate: this.stringDateToDayjs(dto.claimSubmittedDate),
            createdAt: this.stringDateToDayjs(dto.createdAt),
            updatedAt: this.stringDateToDayjs(dto.updatedAt),
            type: dto.type,
        };
    }

    override mapModelToDto(model: MedicalDocumentationModel): MedicalDocumentationResponseDto {
        return {
            id: model.id,
            maskedCustomerId: model.maskedCustomerId,
            maskedInsuranceId: model.maskedInsuranceId,
            maskedDocumentIds: model.maskedDocumentIds,
            medicalCareType: model.medicalCareType,
            accidentDate: this.dayjsFormatForDto(model.accidentDate),
            pastMedicalConditions: model.pastMedicalConditions,
            pastMedicalConditionsDescription: model.pastMedicalConditionsDescription,
            customerComment: model.customerComment,
            canSubmitClaim: model.canSubmitClaim,
            claimSubmitted: model.claimSubmitted,
            claimStatus: model.claimStatus,
            claimNumber: model.claimNumber,
            claimSubmittedDate: this.dayjsFormatForDto(model.claimSubmittedDate),
            createdAt: this.dayjsFormatForDto(model.createdAt),
            updatedAt: this.dayjsFormatForDto(model.updatedAt),
            type: model.type,
        };
    }
}
